import UIElement from './UIElement';

export default abstract class UISubElement<ParentT extends UIElement> extends UIElement {
  public readonly parent: ParentT;

  protected constructor(parent: ParentT, element: HTMLElement) {
    super(element);
    this.parent = parent;
  }
}
